<template>
  <div class="common-table">
    <div class="table-head" :style="{ height: titleHeight + 'px' }">
      <div
        class="head-col-item"
        v-for="col in columns"
        :key="col.title"
        :class="col.className"
        :style="col.colStyle"
      >
        {{ col.title }}
      </div>
    </div>
    <div
      class="table-body"
      ref="scrollWrapper"
      :style="{ height: `calc(100% - ${titleHeight}px)` }"
    >
      <ul>
        <li class="table-body-row" v-for="(row, idx) in tableData" :key="idx">
          <div
            class="cell-item"
            v-for="item in row"
            :key="item.value || item.slot"
            :class="item.className"
            :style="{ height: cellHeight + 'px', ...item.colStyle }"
          >
            <template v-if="item.slot">
              <slot :name="item.slot" :row="data[item.rowIdx]"></slot>
            </template>
            <template v-else> {{ item.value }}</template>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import initBScroll from "@/utils/bScroll";
export default {
  props: {
    columns: {
      type: Array,
      required: true,
      default: () => [],
    },
    data: {
      type: Array,
      required: false,
      default: () => [],
    },
    titleHeight: {
      type: [Number, String],
      default: 80,
    },
    cellHeight: {
      type: [Number, String],
      default: 80,
    },
    isScroll: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // [[{},{}],[{},{}]] 内数组是每一行的数据
    tableData() {
      const resArr = [];
      for (let i = 0; i < this.data.length; i++) {
        // 每一行的列表
        var innerArr = [];
        for (let j = 0; j < this.columns.length; j++) {
          // key 中匹配到的值
          let value;
          // 是否配置了slot，如果有slot，渲染 slot 的内容；当slot为空时，才匹配 key 的值
          if (!this.columns[j].slot) {
            value = this.data[i][this.columns[j].key];
          }
          innerArr.push({
            value,
            rowIdx: i,
            ...this.columns[j],
          });
        }
        resArr.push(innerArr);
      }
      return resArr;
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.isScroll) {
        // console.log(this.$refs.scrollWrapper);
        initBScroll(this.$refs.scrollWrapper, { bounce: false });
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.common-table {
  width: 100%;
  .table-head {
    display: flex;
    height: 80px;
    .head-col-item {
      height: 100%;
      color: $--color-primary;
      font-weight: 600;
      font-size: 18px;
      display: flex;
      align-items: center;
    }
  }
  .table-body {
    position: relative;
    background: #ffffff;
    overflow: hidden;
    .table-body-row {
      display: flex;
      &:nth-child(odd) {
        background: #f7f9fb;
      }
      .cell-item {
        height: 80px;
        display: flex;
        align-items: center;
        color: #666666;
        font-size: 14px;
      }
    }
    ::v-deep .bscroll-vertical-scrollbar {
      z-index: 20 !important;
      .bscroll-indicator {
        background: #dcdfe6 !important;
      }
    }
  }
}
</style>
